const policyRewriteTransition = {
    START : 'start',

    CREATE : 'create',

    SUBMIT : 'submit',

    SUBMIT_FOR_ISSUANCE : 'submit for issuance',

    REVERT_TO_SUBMITTED : 'revert to submitted',

    MARK_AS_ISSUED : 'mark as issued',

    DELETE : 'delete',

    START_RATING : 'start rating',

    GENERATE_RATING : 'generate rating',

    MODIFY_RATING : 'modify rating',

    START_PRICING : 'start pricing',

    MODIFY_PRICING : 'modify pricing',

    REVIEW_CHANGES : 'review changes',

    REFRESH_QUOTE : 'refresh quote',

    GENERATE_RATING_ATTACHMENTS : 'generate rating attachments'

};

angular.module('gw-um-j2js')
    .constant('policyRewriteTransition', policyRewriteTransition);